import React, { Component } from 'react'
import { withStyles } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import Card from '@material-ui/core/Card'
import CardActionArea from '@material-ui/core/CardActionArea'
import CardActions from '@material-ui/core/CardActions'
import CardContent from '@material-ui/core/CardContent'
import CardMedia from '@material-ui/core/CardMedia'
import Button from '@material-ui/core/Button'
import Fab from '@material-ui/core/Fab'

import Typography from '@material-ui/core/Typography'
import Collapse from '@material-ui/core/Collapse'
import IconButton from '@material-ui/core/IconButton'
import FavoriteIcon from '@material-ui/icons/Favorite'
import ShareIcon from '@material-ui/icons/Share'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import ArrowBackIosRoundedIcon from '@material-ui/icons/ArrowBackIosRounded'
import ArrowForwardIosRoundedIcon from '@material-ui/icons/ArrowForwardIosRounded'
import ExpandMoreRoundedIcon from '@material-ui/icons/ExpandMoreRounded'
import UnfoldMoreRoundedIcon from '@material-ui/icons/UnfoldMoreRounded'
import UnfoldLessRoundedIcon from '@material-ui/icons/UnfoldLessRounded'
import UnfoldMoreIcon from '@material-ui/icons/UnfoldMore'
import clsx from 'clsx'
import ListUser from '../ShowListUser'
import styles from './styles'
//from ant design
import { Menu, Dropdown, Icon, message } from 'antd'
//redux
import { connect } from 'react-redux'
import { compose, bindActionCreators } from 'redux'
import organizationActions from '../../../redux/organization/actions'

class OrganiItem extends Component {
    state = {
        bossName: 'Chưa có Trưởng Phòng',
        loading: false,
        expanded: false,
        beginText: 0,
        finnishText: 0,
    }

    handleExpandClick = () => {
        this.setState((prevState, props) => ({ expanded: !prevState.expanded }))
    }

    componentDidMount() {}

    componentWillReceiveProps(nextProps) {
        this.setState((prevState, props) => ({ expanded: false }))
        console.log(
            'componentWillReceiveProps: ',
            nextProps.currentOrganization
        )

        if (nextProps.listUserInOrgani !== this.props.listUserInOrgani) {
            console.log(
                'componentWillReceiveProps listUserInOrgani: ',
                nextProps.listUserInOrgani
            )
        }
    }
    _arrowBack = () => {}
    _arrowForward = () => {}
    showContent = () => {
        const { classes, currentOrganization } = this.props
        let html = null
        html = (
            <div>
                <Typography
                    variant="subtitle1"
                    color="textSecondary"
                    component="p"
                >
                    {currentOrganization.ext_data.description}
                </Typography>
            </div>
        )
        return html
    }
    render() {
        const { classes, currentOrganization } = this.props
        const { expanded } = this.state
        return (
            <Card className={classes.card}>
                <CardActionArea>
                    <CardMedia
                        className={classes.media}
                        image={currentOrganization.ext_data.avatarOrgani}
                        title={currentOrganization.name}
                    />
                    <CardContent style={{ textAlign: 'center', marginTop: 10 }}>
                        <Typography
                            gutterBottom
                            variant="h5"
                            component="h2"
                            style={{ color: 'red' }}
                        >
                            {currentOrganization.name}
                        </Typography>
                    </CardContent>
                </CardActionArea>

                <CardContent>
                    <Typography
                        variant="subtitle1"
                        color="textSecondary"
                        component="p"
                    >
                        {currentOrganization.ext_data.description}
                    </Typography>
                </CardContent>

                <CardActions
                    style={{
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'flex-end',
                        marginRight: 10,
                    }}
                >
                    <IconButton
                        style={{
                            color: 'blue',
                        }}
                        onClick={this._arrowBack}
                    >
                        <ArrowBackIosRoundedIcon />
                    </IconButton>
                    <IconButton
                        style={{
                            color: 'green',
                        }}
                        onClick={this._arrowForward}
                    >
                        <ArrowForwardIosRoundedIcon />
                    </IconButton>
                    <IconButton
                        style={{
                            color: 'red',
                            size: 28,
                        }}
                        onClick={this.handleExpandClick}
                        aria-expanded={expanded}
                    >
                        {!expanded ? (
                            <UnfoldMoreIcon fontSize="large" />
                        ) : (
                            <UnfoldLessRoundedIcon fontSize="large" />
                        )}
                    </IconButton>
                </CardActions>
                <Collapse in={expanded} timeout="auto" unmountOnExit>
                    <CardContent>
                        <ListUser />
                    </CardContent>
                </Collapse>
            </Card>
        )
    }
}

const mapStateToProps = state => {
    return {}
}

const mapDispatchToProps = dispatch => {
    return {
        modalActionCreators: bindActionCreators(
            organizationActions.action,
            dispatch
        ),
    }
}

const withConnect = connect(
    mapStateToProps,
    mapDispatchToProps
)

export default compose(
    withConnect,
    withStyles(styles)
)(OrganiItem)
